export const MAIN_LOGO = '/images/v4-logo.png';
export const HEADER_IMAGE = "/images/header-image.svg";
export const STORAGE_IMAGE = "/images/storage.svg";
export const OUR_PRODUCT = "/images/our-product.png";


export const AI = '/images/ai.svg';
export const REACT_LOGO = "/images/react-logo.svg";
export const NODE_LOGO = "/images/node-logo.svg";
export const DJANGO = "/images/django.svg";
export const AWS = "/images/aws.svg";
export const WEBPACK = "/images/webpack.svg";
export const FIGMA = '/images/Figma.svg';
export const ELASTIC_SEARCH = "/images/elasticsearch.svg";
export const JAVASCRIPT = '/images/javascript.svg';
export const REACT_NATIVE = "/images/react-native.svg";
export const PYTHON = '/images/python.svg';
export const CELERY = "/images/Celery.svg";
export const MATERIAL_UI = '/images/material-ui.svg';
export const ICO_MOON = '/images/ico-moon.svg';
export const POSTGRE_SQL = '/images/postgre-SQL.svg';
export const REDUX = '/images/redux.svg';
export const WEB_SOCKETS = '/images/web-sockets.svg';
export const NETLIFY = '/images/netlify.svg';
export const REDIS = "/images/redis.svg";
export const GATSBY = "/images/gatsby.svg";

export const DEVELOPING = '/images/icon_developing.svg';
export const PROCESS_WE_FOLLOW = '/images/process-we-follow.svg';
export const OUR_TEAM = "/images/our-team.svg"
export const PRODUCT_DESIGN = "/images//product-design.svg";

export const FACEBOOK = "/images/facebook.svg";
export const INSTAGRAM = '/images/instagram-logo.svg';
export const LINKEDIN = '/images/linkedin.svg';
export const TWITTER = '/images/twitter.svg';

export const MENU_ICON = '/images/menu-icon.png';

